import ContactForm from "../../components/ContactForm/ContactForm";
import { Envelope, ClockHistory, LightningCharge, GeoAlt } from "react-bootstrap-icons";
import "./Contact.css";

const contactInfo = [
  {
    icon: <Envelope />,
    title: "Email Us",
    lines: ["support@solochat.me"],
    sub: "For general enquiries and support",
  },
  {
    icon: <ClockHistory />,
    title: "Support Hours",
    lines: ["Mon – Fri: 9:00 – 18:00", "Saturday: 10:00 – 14:00"],
    sub: "WAT (GMT+1)",
  },
  {
    icon: <LightningCharge />,
    title: "Response Time",
    lines: ["Within 24 hours"],
    sub: "We reply to every message",
  },
  {
    icon: <GeoAlt />,
    title: "Headquarters",
    lines: ["SoloChat", "Lagos, Nigeria"],
    sub: "Serving users worldwide",
  },
];

function Contact() {
  return (
    <div className="contactPage">
      <section className="contactHero">
        <div className="contactHeroInner">
          <div className="contactBadge">We'd love to hear from you</div>
          <h1>Contact Us</h1>
          <p>
            Questions, feedback or just want to say hi? Send us a message and
            our team will get back to you as soon as possible.
          </p>
        </div>
      </section>

      <div className="contactLayout">
        <aside className="contactInfo">
          {contactInfo.map((c) => (
            <div key={c.title} className="contactInfoCard">
              <div className="contactInfoIcon">{c.icon}</div>
              <div className="contactInfoBody">
                <h3>{c.title}</h3>
                {c.lines.map((l) => (
                  <p key={l}>{l}</p>
                ))}
                <small>{c.sub}</small>
              </div>
            </div>
          ))}
        </aside>

        <div className="contactFormWrap">
          <div className="contactFormHeader">
            <h2>Send us a message</h2>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default Contact;
